import { render, staticRenderFns } from "./boardSorting.vue?vue&type=template&id=3965bb4e&"
import script from "./boardSorting.vue?vue&type=script&lang=js&"
export * from "./boardSorting.vue?vue&type=script&lang=js&"
import style0 from "../less/select.less?vue&type=style&index=0&module=%24&lang=css&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$"] = (style0.locals || style0)
        Object.defineProperty(this, "$", {
          configurable: true,
          get: function () {
            return cssModules["$"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["../less/select.less?vue&type=style&index=0&module=%24&lang=css&"], function () {
          var oldLocals = cssModules["$"]
          if (oldLocals) {
            var newLocals = require("../less/select.less?vue&type=style&index=0&module=%24&lang=css&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$"] = newLocals
              require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js").rerender("3965bb4e")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3965bb4e')) {
      api.createRecord('3965bb4e', component.options)
    } else {
      api.reload('3965bb4e', component.options)
    }
    module.hot.accept("./boardSorting.vue?vue&type=template&id=3965bb4e&", function () {
      api.rerender('3965bb4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/header/include/boardSorting.vue"
export default component.exports